/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliActivityDto } from '../../models/amoxcalli-activity-dto';
import { AmoxcalliUpdateActivityDto } from '../../models/amoxcalli-update-activity-dto';

export interface ApiActivitiesIdPut$Plain$Params {
  id: string;
      body?: AmoxcalliUpdateActivityDto
}

export function apiActivitiesIdPut$Plain(http: HttpClient, rootUrl: string, params: ApiActivitiesIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliActivityDto>> {
  const rb = new RequestBuilder(rootUrl, apiActivitiesIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliActivityDto>;
    })
  );
}

apiActivitiesIdPut$Plain.PATH = '/api/activities/{id}';
